module.exports = __webpack_public_path__ + "static/about-cd62bc0292a7dc10fb880734a63b9584.svg";